module.exports = __webpack_public_path__ + "static/assets/634e7a1821131616e02be687737b0c1a.svg";